<template>
    <transition :name="toggleTransition" @before-enter="beforeEnter" @after-enter="onEnter" @after-leave="onLeave">
        <div class="ui-modal ui-modal__mask" :class="classes" :role="role" v-show="isOpen">
            <div class="ui-modal__wrapper" ref="backdrop" :class="{ 'has-dummy-scrollbar': preventShift }" @click="dismissOnBackdrop && closeModal($event)">
                <div class="ui-modal__container" ref="container" tabindex="-1" @keydown.esc="dismissOnEsc && closeModal($event)">
                    <div class="ui-modal__header" v-if="!removeHeader">
                        <slot name="header">
                            <h1 class="ui-modal__header-text">{{ title }}</h1>
                        </slot>
                        <button type="button" class="close" @click="closeModal"><span>&times;</span></button>
                    </div>

                    <div class="ui-modal__body">
                        <slot></slot>
                    </div>

                    <div class="ui-modal__footer" v-if="hasFooter">
                        <slot name="footer"></slot>
                    </div>

                    <div class="ui-modal__focus-redirect" tabindex="0" @focus.stop="redirectFocus">
                    	
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import classlist from 'util/classlist';

export default {
    name: 'sub-modal',

    props: {
    	/*scroll:{
    		type:String,
    		default:'-10px'
    	},*/
        title: {
            type: String,
            default: 'UiModal title'
        },
        size: {
            type: String,
            default: 'normal' // 'small', 'normal', or 'large'
        },
        role: {
            type: String,
            default: 'dialog' // 'dialog' or 'alertdialog'
        },
        transition: {
            type: String,
            default: 'scale' // 'scale', or 'fade'
        },
        removeHeader: {
            type: Boolean,
            default: false
        },
        removeCloseButton: {
            type: Boolean,
            default: false
        },
        preventShift: {
            type: Boolean,
            default: false
        },
        dismissible: {
            type: Boolean,
            default: true
        },
        dismissOn: {
            type: String,
            default: 'backdrop esc close-button'
        }
    },

    data() {
        return {
            isOpen: false,
            lastfocusedElement: null,
         //   maskH:'' //最外层modal-mask高度
        };
    },

    computed: {
        classes() {
            return [
                `ui-modal--size-${this.size}`,
                { 'has-footer': this.hasFooter },
                { 'is-open': this.isOpen }
            ];
        },

        hasFooter() {
            return Boolean(this.$slots.footer);
        },

        toggleTransition() {
            return `ui-modal--transition-${this.transition}`;
        },

        dismissOnBackdrop() {
            return this.dismissOn.indexOf('backdrop') > -1;
        },

        dismissOnCloseButton() {
            return this.dismissOn.indexOf('close-button') > -1;
        },

        dismissOnEsc() {
            return this.dismissOn.indexOf('esc') > -1;
        }
    },

    watch: {
        isOpen() {
            this.$nextTick(() => {
                this[this.isOpen ? 'onOpen' : 'onClose']();
            });
        }
    },

    beforeDestroy() {
        if (this.isOpen) {
            this.teardownModal();
        }
    },

    methods: {
        open() {
            this.isOpen = true;
        },

        close() {
            this.isOpen = false;
        },

        closeModal(e) {
            if (!this.dismissible) {
                return;
            }
            if (e.currentTarget === this.$refs.backdrop && e.target !== e.currentTarget) {
                return;
            }

            this.isOpen = false;
        },

        onOpen() {
        //	console.log(document.activeElement)
            this.lastfocusedElement = document.activeElement;
            this.$refs.container.focus();

            classlist.add(document.body, 'ui-modal--is-open');

            this.$emit('open');
        },

        onClose() {
            this.teardownModal();
            this.$emit('close');
        },

		teardownModal() {
            document.removeEventListener('focus', this.restrictFocus, true);

            if (this.lastfocusedElement) {
                this.lastfocusedElement.focus();
            }
        },
		beforeEnter(){
			this.$emit('beforeReveal')
		},
        onEnter() {
            this.$emit('reveal');
        },

        onLeave() {
            this.$emit('hide');

            classlist.remove(document.body, 'ui-modal--is-open');
        }
    },

    components: {
    }
};
</script>

<style lang="scss" scoped>

$ui-modal-transition-duration   : 0.3s !default;
$ui-modal-mask-background       : rgba(black, 0.5) !default;
$ui-modal-header-height         : calc(56px);
$ui-modal-footer-height         : calc(70px);

$ui-modal-font-size             : calc(14px);
$ui-modal-header-font-size      : calc(16px);

.ui-modal {

    &.has-footer {
        .ui-modal__body {
            max-height: calc(100vh - #{$ui-modal-header-height + $ui-modal-footer-height});
        }
    }

    &:not(.has-footer) {
        .ui-modal__body {
            padding: 16px 24px 24px;
        }
    }
}

.ui-modal--is-open {
    overflow: hidden;
}


.ui-modal__mask {
    background-color: rgba(0, 0, 0, 0.3);
    left: 0px;
    overflow: auto;
    position: absolute;
    top: -50px;
    width: 100%;
    z-index: 9998;
    height: calc(100% + 50px);

}

.ui-modal__wrapper {
	 padding-top: 100px;
   
    vertical-align: middle;
    overflow-x: hidden;

    &.has-dummy-scrollbar {
        overflow-y: scroll;
    }
}

.ui-modal__container {
    background-color: white;
    border-radius: calc(2px);
    box-shadow: 0 2px 8px rgba(black, 0.33);
    margin: 0 auto;
    max-height: 100vh;
    max-width: 100vw;
    outline: none;
    overflow: hidden;
    padding: 0;
    transition: all $ui-modal-transition-duration ease;
    width: calc(528px);
}

.ui-modal__header {
    align-items: center;
    background-color: #F5F5F5;
    box-shadow: 0 1px 1px rgba(black, 0.16);
    display: flex;
    height: $ui-modal-header-height;
    padding: 0 20px;
    position: relative;
    z-index: 1;
}

.ui-modal__header-text {
    align-items: center;
    display: flex;
    flex-grow: 1;
    font-size: $ui-modal-header-font-size;
    font-weight: normal;
    margin: 0;
}

.ui-modal__close-button {
    margin-left: auto;
    margin-right: calc(-8px);
}

.ui-modal__body {
    max-height: calc(100vh - #{$ui-modal-header-height});
    overflow-y: auto;
    padding: 20px;
}

.ui-modal__footer {
    align-items: center;
    display: flex;
    height: $ui-modal-footer-height;
    justify-content: flex-end;
    padding: 20px;

    .ui-button {
        margin-left: calc(8px);

        &:first-child {
            margin-left: 0;
        }
    }
}

// ================================================
// Sizes
// ================================================

.ui-modal--size-large {
    .ui-modal__container {
        width: calc(848px);
    }
}

.ui-modal--size-small {
    .ui-modal__container {
        width: calc(320px);
    }
}

// ================================================
// Transitions
// ================================================

.ui-modal--transition-fade-enter,
.ui-modal--transition-fade-leave-active {
    opacity: 0;
}

.ui-modal--transition-scale-enter,
.ui-modal--transition-scale-leave-active {
    opacity: 0;

    .ui-modal__container {
        transform: scale(1.1);
    }
}
</style>



// WEBPACK FOOTER //
// SubModal.vue?6fe8bb78